export const SECOND_IN_MS = 1000;
export const MINUTE_IN_MS = 60 * SECOND_IN_MS;
export const HOUR_IN_MS = 60 * MINUTE_IN_MS;
export const DAY_IN_MS = 24 * HOUR_IN_MS;
export const TWO_MINUTES_IN_MS = 2 * 60 * SECOND_IN_MS;
export const TEN_MINUTES_IN_MS = 10 * 60 * SECOND_IN_MS;

export const MINUTE_IN_SECONDS = 60;
export const HOUR_IN_SECONDS = 60 * MINUTE_IN_SECONDS;
export const YEAR_IN_DAYS = 365;
